import Vue from "vue";
import Vuex from "vuex";
import { privateApi } from "@/api";

Vue.use(Vuex);

const salesStore = {
  state: {
    sales: [],
    salesEstimates: [],
    saleOptionalValues: []
  },
  getters: {
    getSales(state) {
      return state.sales;
    },
    getSalesEstimates(state) {
      return state.salesEstimates;
    },
    getSaleOptionalValues(state) {
      return state.saleOptionalValues;
    }
  },
  mutations: {
    setSales(state, value) {
      state.sales = value;
    },
    addSale(state, value) {
      state.sales.push(value);
    },
    updateSale(state, value) {
      state.sales = state.sales.filter(i => i.id !== value.id);
      state.sales.push(value);
    },
    deleteSale(state, value) {
      state.sales = state.sales.filter(i => i.id !== value.id);
    },
    setSalesEstimates(state, value) {
      state.salesEstimates = value;
    },
    addSaleEstimate(state, value) {
      state.salesEstimates.push(value);
    },
    updateSaleEstimate(state, value) {
      state.salesEstimates = state.salesEstimates.filter(
        x => x.id !== value.id
      );
      state.salesEstimates.push(value);
    },
    removeSaleEstimate(state, value) {
      state.salesEstimates = state.salesEstimates.filter(
        x => x.id !== value.id
      );
    },
    setSaleOptionalValues(state, value) {
      state.saleOptionalValues = value;
    },
    updateSaleOptionalValue(state, value) {
      let d = state.saleOptionalValues.filter(
        x => x.value_number !== value.value_number
      );
      d.push(value);
      state.saleOptionalValues = d;
    },
    deleteSaleOptionalValue(state, value) {
      state.saleOptionalValues = state.saleOptionalValues.filter(
        x => x.value_number !== value.value_number
      );
    }
  },
  actions: {
    async loadSales({ commit }) {
      const res = await privateApi.getSales();
      commit("setSales", res);
      return res;
    },
    async addSales({ commit }, item) {
      const res = await privateApi.postSale(item);
      commit("addSale", res);
      return res;
    },
    async updateSale({ commit }, item) {
      const res = await privateApi.putSale(item.id, item);
      commit("updateSale", res);
      return res;
    },
    async deleteSale({ commit }, item) {
      await privateApi.deleteSale(item.id);
      commit("deleteSale", item);
      return item;
    },
    async loadSalesEstimates({ commit }) {
      const res = await privateApi.getSalesEstimates();
      commit("setSalesEstimates", res);
      return res;
    },
    async addSaleEstimate({ commit }, item) {
      const res = await privateApi.postSaleEstimate(item);
      commit("addSaleEstimate", res);
      return res;
    },
    async updateSaleEstimate({ commit }, item) {
      const res = await privateApi.patchSaleEstimate(item.id, item);
      commit("updateSaleEstimate", res);
      return res;
    },
    async deleteSaleEstimate({ commit }, item) {
      await privateApi.deleteSaleEstimate(item.id);
      commit("removeSaleEstimate", item);
      return item;
    },
    async loadSaleOptionalValues({ commit }) {
      const res = await privateApi.getSaleOptionalValues();
      commit("setSaleOptionalValues", res);
    },
    async addSaleOptionalValue({ commit }, item) {
      const res = await privateApi.postSaleOptionalValue(item);
      commit("updateSaleOptionalValue", res);
    },
    async updateSaleOptionalValue({ commit }, item) {
      const res = await privateApi.patchSaleOptionalValue(item.id, item);
      commit("updateSaleOptionalValue", res);
    },
    async deleteSaleOptionalValue({ commit }, item) {
      await privateApi.deleteSaleOptionalValue(item.id);
      commit("deleteSaleOptionalValue", item);
    }
  }
};

export default salesStore;
